"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTypeToJSON = exports.PaymentTypeFromJSONTyped = exports.PaymentTypeFromJSON = exports.PaymentType = void 0;
/**
 * Method of payment used for bill
 * @export
 */
exports.PaymentType = {
    PaymentTypeUnknown: 'PAYMENT_TYPE_UNKNOWN',
    Card: 'CARD',
    Invoice: 'INVOICE',
    Offer: 'OFFER'
};
function PaymentTypeFromJSON(json) {
    return PaymentTypeFromJSONTyped(json, false);
}
exports.PaymentTypeFromJSON = PaymentTypeFromJSON;
function PaymentTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PaymentTypeFromJSONTyped = PaymentTypeFromJSONTyped;
function PaymentTypeToJSON(value) {
    return value;
}
exports.PaymentTypeToJSON = PaymentTypeToJSON;
